import { instance, auth0settings } from '../helpers/settings';

class AuthService {
	authenticate(isAuthenticated, getAccessTokenSilently) {
		if (isAuthenticated) {
			return getAccessTokenSilently({
				authorizationParams: {
					audience: auth0settings.audience,
					scope: auth0settings.scope
				}
			})
				.then(response => {
					localStorage.setItem('apiToken', response);
					instance.defaults.headers.authorization = `Bearer ${response}`;

					return new Promise((resolve, reject) => resolve(response));
				})
				.catch(error => new Promise((resolve, reject) => reject(error)));
		}

		return new Promise((resolve, reject) => reject(error));
	}

	getToken() {
		return localStorage.getItem('apiToken');
	}
}

export default new AuthService();
